import styled from 'styled-components'
import { ContainerProps } from './types'
import backArrow from '@assets/images/icons/LeftArrowIcon'

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection || 'row'};
  height: 100vh;
  width: 100%;
  overflow: auto;
`
export const ContractContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 30px;
  @media (max-width: 900px) {
    padding: 20px;
    gap: 16px;
  }
  @media (max-width: 600px) {
    padding: 10px;
    gap: 12px;
  }
`
export const ArrowButton = styled.button`
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
`
export const ArrowIcon = styled.img.attrs({
  src: backArrow,
  alt: 'Return icon',
})``

export const Button = styled.button.attrs(({ type }) => ({
  type: type || 'button',
}))`
  background-color: #060606;
  border: 1px solid #060606;
  color: #ffffff;
  font-size: 14px;
  line-height: 22px;
  padding: 12px 20px;
  cursor: pointer;
  letter-spacing: 2px;
  text-transform: uppercase;
  min-width: 350px;
  margin-top: 24px;
  height: auto;
  white-space: normal;
  word-wrap: break-word;

  @media (max-width: 900px) {
    min-width: 280px;
    font-size: 13px;
    padding: 10px 16px;
    letter-spacing: 1.5px;
  }

  @media (max-width: 600px) {
    min-width: 100%;
    max-width: 100%;
    font-size: 12px;
    padding: 10px 12px;
    letter-spacing: 1px;
    margin-top: 16px;
  }
`
